import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fsa_hsa_fd~1
			paywall: {
				experiment: () =>
					import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fsa_hsa_fd'),
			},
		},
	},
]

export default config
